import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import { Tooltip } from 'reactstrap';

import { useAppDispatch, useAppSelector } from '@/redux';
import { setBrowserInfos } from '@/redux/slices/cart.slice';
import { addToast } from '@/redux/slices/toast.slice';

import InputGroup from '@/components/common/form/InputGroup';
import { LoggerService } from '@/services';
import { useServices } from '@/services/useServices';

import { NS } from '@/constants';
import { LOG_MSG, LOG_URL } from '@/constants/logger';

export const InputCvc = ({ t, cardInfo, setCvcIsValid, showPlaceholder = true }) => {
  const dispatch = useAppDispatch();
  const userId = useAppSelector(({ user }) => user.content?._id || '');
  const cartId = useAppSelector(({ cart }) => cart.content?.id);
  const storeId = useAppSelector(({ root }) => root.storeConf.storeId);

  const { hipayService } = useServices();
  const [toolTipOpen, setToolTipOpen] = useState(false);
  const [cardCvc, setCardCvc] = useState();

  useEffect(() => {
    if (cardCvc && cardInfo) {
      const subscription = hipayService.updateSaveCreditCardCvc({
        request_id: 0,
        card_token: cardInfo.token,
        card_expiry_month: cardInfo.cardExpireMonth,
        card_expiry_year: cardInfo.cardExpireYear,
        card_holder: cardInfo.cardHolder,
        cvc: cardCvc,
      }).subscribe(() => {
        dispatch(setBrowserInfos(hipayService.getBrowserInfo()));
        setCvcIsValid(true);
      }, (err) => {
        let errorCode;
        const messages = ['payMode.hipayErrors.generic'];

        try {
          // We receive a stringified object with `code` & `message`properties
          const hipayError = JSON.parse(err);

          if (hipayError?.code) {
            errorCode = hipayError.code;
          }
        } catch (e) {
          // Parsing of the error did not work
        }

        if (errorCode) {
          // Error in CVV, use the specific message label
          if (errorCode === 400) {
            messages.unshift('payMode.cvcUpdateError');
          } else {
            messages.unshift(`payMode.hiPayErrors.${errorCode}`);
          }
        }

        LoggerService.sendLog(cartId, LOG_MSG.HIPAY.UPDATE_TOKEN_ERROR, storeId, LOG_URL.PAY, userId, err);
        dispatch(addToast({ msg: t(messages, { ns: NS.CHECKOUT }) }));
        setCvcIsValid(false);
      });

      return () => {
        subscription.unsubscribe();
      };
    }
  }, [cardCvc, cardInfo]);

  const toggleToolTip = () => {
    setToolTipOpen(!toolTipOpen);
  };

  return (
    <>
      <InputGroup
        buttonText={t('btn.ok')}
        onValidate={setCardCvc}
        placeholder={showPlaceholder ? t('payMode.cvc', { ns: NS.CHECKOUT }) : null}
        marginBottom={false}
        minLength={3}
        maxLength={4}
        small
      />
      <span className="mandatory" id="mandatoryToolTip" data-test-id="mandatoryToolTip">*</span>
      <Tooltip placement="top" target="mandatoryToolTip" isOpen={toolTipOpen} toggle={toggleToolTip}>
        {t('payMode.cvcIsMandatory', { ns: NS.CHECKOUT })}
      </Tooltip>
    </>
  );
};

InputCvc.propTypes = {
  t: PropTypes.func.isRequired,
  setCvcIsValid: PropTypes.func.isRequired,
  cardInfo: PropTypes.object,
  showPlaceholder: PropTypes.bool,
};
export default InputCvc;
